import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';

import { Theme } from '../../config/theme';

export default class UserImage extends Component {
  render() {
    return (
      <div className={css(styles.container, this.props.styles)}>
        <img className={css(styles.image)} src={this.props.image} alt="Profile" />
      </div>
    );
  }
}

UserImage.defaultProps = {
  styles: null,
};

UserImage.propTypes = {
  styles: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ])),
  image: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    zIndex: 1,
    width: 60,
    height: 60,
    borderRadius: 30,
    borderWidth: 2,
    borderColor: '#fff',
    borderStyle: 'solid',
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset',
    overflow: 'hidden',

    [Theme.mobile_query]: {
      height: 50,
      width: 50,
    },
  },
  image: {
    zIndex: -1,
    cursor: 'pointer',
    display: 'block',
    height: '100%',
    width: '100%',
  },
});



// WEBPACK FOOTER //
// ./src/components/UserImage/index.js